<template>
  <div class="con" v-loading="fullscreenLoading" style="min-height: 633px;background: #fff;">
    <div class="logDetail">
      <img src="../../assets/images/update-log.png">
      <div class="logMenu">
        <div>
          <div>
          <span v-for="(item, index) in subSystems" :key="index"
                :class="acyiveIndex === index?'activeSub':''"
          @click="chooseHandle(index, item.code)">
          {{item.name}}
            <i class="line-1"></i>
          </span>
          </div>
        </div>
      </div>
      <div style="display: flex;justify-content: center;align-items: center">
        <div style="width: 1200px;margin-bottom: 30px">
      <el-row v-for="(item,index) in productUpdateList" :key="item.id" >
        <el-col :span="4">
          <p class="time_left">{{(item.versionUpdateDateStr).slice(0,10)}}</p>
        </el-col>
        <el-col :span="20" class='update_con_r'>
          <h4 @click="detail_show(index, item.id)">
            <i class="circle circle_show" v-if='!item.show'></i>
            <i class="circle" v-if='item.show'></i>
            {{item.versionCode}}
            <i class="el-icon-arrow-down" style="margin-left:10px;" v-if='item.show'></i>
            <i class="el-icon-arrow-up" style="margin-left:10px;" v-if='!item.show'></i>
          </h4>
          <p class="keyWord">{{item.updateKeyword}}</p>
          <p v-if='item.show'>{{item.content}}</p>
          <ul>
            <li v-for="child in item.versionUpdateDetailModelList" :key="child.id" v-if='item.show'>
              <p>{{child.shortDes}}</p>
              <p>{{child.description}}</p>
            </li>
          </ul>
        </el-col>
      </el-row>
      </div>
      </div>
      </div>
  </div>
</template>
<script>
import { getUpdateLog, getUpdateLogDetail} from '@/api/manage-api.js'
import { getUpdateLogList, getUpdateLogNew } from '@/api/log.js'
export default {
  name: 'updateLog',
  data () {
    return {
      acyiveIndex: 0,
      subSystems: [],
      productUpdateList: [],
      fullscreenLoading: false,
      page: 1,
      isLastPage: false,
      lastPage: 0,
      limit: 6,
      code: '',
    }
  },
  methods: {
    // 滚定监听
    handleScroll(e){
      let scrollBottom =
              e.target.scrollingElement.scrollHeight -
              e.target.scrollingElement.scrollTop -
              e.target.scrollingElement.clientHeight
      if(scrollBottom === 0) {
        // 滚动到底部
        if(this.isLastPage) {
        } else {
          if (this.page< this.lastPage) {
            this.page = this.page+1
            this.getUpdateLog(this.code)
          }

        }
        // this.getUpdateLog(code)
      }
    },
    chooseHandle (index, code) {
      this.acyiveIndex = index
      this.page = 1
      this.code = code
      this.getUpdateLog(code)
    },
    getUpdateLogList(arr) {
      let that = this
      getUpdateLogList(arr).then(res => {
        let index = 0
        res.data.result.map(function(it, i){
          if(it.code === that.$route.query.code) {
            index = i
          }
        })
        this.acyiveIndex = index
        this.subSystems = res.data.result
        this.code = res.data.result[index].code
        this.getUpdateLog(res.data.result[index].code)
      })
    },
    getUpdateLog(code) {
      getUpdateLogNew(this.page, this.limit, code).then(res => {
        this.fullscreenLoading = false
        let result = res.data.result.list
        if(result.length!=0) {
          for (let item of result) {
            item.show = false
            item.updateKeyword = item.updateKeyword.replace(/,/g, ' | ')
          }
          this.isLastPage = res.data.result.isLastPage
          this.lastPage = res.data.result.lastPage
          if(!res.data.result.isFirstPage) {
            let newarr = this.productUpdateList.concat(result)
            this.productUpdateList = newarr
          }
          if(res.data.result.isFirstPage){
            let index = 0
            res.data.result.list[index].show = true
            this.getDetail(index, result[index].id)
            this.productUpdateList = result
          }

        } else {
          this.productUpdateList = []
        }

      })
    },
    getDetail(index, id){
      getUpdateLogDetail(id).then(res => {
        if (res.data.success) {
          this.productUpdateList[index].versionUpdateDetailModelList = res.data.result.versionUpdateDetailModelList
        }
      })
    },
    detail_show(index, id) {
      let model = this.productUpdateList[index].versionUpdateDetailModelList
      if (model === null || model === '' || model.length === 0) {
        if (!this.productUpdateList[index].show) {
          this.getDetail(index, id)
        }
      }
      this.productUpdateList[index].show = !this.productUpdateList[index].show
    }
  },
  mounted() {
    let arr = [{
      name: '智盈',
      perms: 'ZY_INTELLIQUOR'
    }]
    let subSystems = arr.concat(Lockr.get('subSystems'))
    let newarr = []
    subSystems.map(function(it, ind){
      newarr.push({
        name: it.name,
        code: it.perms
      })
    })
    this.getUpdateLogList(newarr)
    window.addEventListener('scroll',this.handleScroll,true)
  },
  created() {
  },
  beforeCreate() {
  },
  components: {
  }
}
</script>

<style scoped>
  .logMenu {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
    padding: 10px 0;
  }
  .logMenu > div {
    /*border-bottom: 1px solid #E6E6E6;*/
  }
  .logMenu > div> div {
    margin: 0 -8px;
  }
  .logMenu span {
    font-size: 16px;
    position: relative;
    text-align: center;
    display: inline-block;
    /*background-color: #FAFAFA;*/
    color: #000000;
    font-weight: bold;
    margin: 0 8px;
    /*border-top: 1px solid #E6E6E6;*/
    /*border-left: 1px solid #E6E6E6;*/
    /*border-right: 1px solid #E6E6E6;*/
    /*border-bottom: 1px solid #E6E6E6;*/
    padding: 8px 15px;
    cursor: pointer;

  }
  .line-1 {
    position: absolute;
    bottom: 0px;
    left: 50%;
    margin-left: -15px;
    height: 3px;
    width: 30px;
    display: inline-block;
    background-color:  #1980FF;
    visibility: hidden;
  }
  .logMenu span.activeSub {
    background-color: #ffffff;
    color: #1980FF;
  }
  .logMenu span.activeSub .line-1 {
    visibility: visible;
  }
.time_left{
  line-height: 28px;
  text-align: right;
  box-sizing: border-box;
  padding-right: 20px;
  font-size: 18px;
  margin: 0;
  color: #333;
}
.update_con_r{
  position: relative;
  border-left: 2px solid #D8D8D8;
  padding-left: 20px;
  cursor: pointer;
  min-height: 120px;
}
.update_con_r h4 i.circle{
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background: #1980FF;
  display: inline-block;
  margin-right: 20px;
  position: absolute;
  top: 0;
  left: -6px;
}
.update_con_r h4 i.circle_show{
  background: #D8D8D8 !important;
}
.update_con_r h4 i{
  font-size: 14px;
  color: #000
}
.update_con_r h4{
  font-size: 18px;
  margin-bottom: 10px;
  margin-top: 0px
}
.update_con_r>p.keyWord{
  color: #1980FF;
}
.update_con_r>p, .update_con_r>p.keyWord{
  box-sizing: border-box;
  line-height: 25px;
  /*padding-left: 20px;*/
  font-size: 14px;
  margin: 0
}
.update_con_r ul{
  box-sizing: border-box;
  margin: 0;
  margin-bottom: 20px;
  padding-left: 9px;
}
.update_con_r ul li{
  list-style: none;
  position: relative;
}
.update_con_r ul li:before{
  content: ' ';
  height: 5px;
  width: 5px;
  border-radius: 50%;
  background: #D8D8D8;
  display: inline-block;
  position: absolute;
  top: 6px;
  left: -5px;
}
.update_con_r ul li p{
  margin: 2px 5px;
  font-size: 14px;
}

.update_con{
  width: 100%;
  height: auto;
}
.logDetail{
  width: 100%;
  margin: 0 auto;
  /*height: 500px;*/
  background: #fff;
  text-align: left;
}
.logDetail img{
  width: 100%;
  margin-bottom: 20px;
}
</style>
